import { useWasteId } from '../shared/useWasteId';
import { useWasteService } from 'domain/shared/waste';
import { Show } from 'framework/show';
import ViewWastePageContent from './ViewWastePageContent';

const WasteViewPage = () => {
  const { getById } = useWasteService();
  const id = useWasteId();
  return (
    <Show getDataMethod={() => getById(id)}>
      <ViewWastePageContent />
    </Show>
  );
};

export default WasteViewPage;
